import clsx from 'clsx';
import React from 'react';

import Label from '@/src/components/common/Elements/Label/Label';
// import AccessList from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/AccessList/AccessList';
import CollapsedList from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/CollapsedList/CollapsedList';
import FormattedDate from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/FormattedDate/FormattedDate';
import FormattedDateWithUser from '@/src/components/project/Inbox2/components/EntryPanel/Common/InfoPanel/DetailItems/FormattedDateWithUser/FormattedDateWithUser';
import { getUserWithEmailDisplay } from '@/src/components/project/Inbox2/models/InboxEntry';
import { cn } from '@/src/util/ui';

import { useEmailThreadEntryViewer } from '../../../../store/emailThreadEntryViewer.store';

const EmailDetails = () => {
  const { selectedEmailEntry } = useEmailThreadEntryViewer();
  const fromRecipients = selectedEmailEntry.from
    .map((from) => getUserWithEmailDisplay(from))
    .join(',');
  const labelClasses = cn('tw-min-w-[90px]', 'tw-mr-[10px]');
  const mainContainerClasses = cn('tw-mb-[12px]');

  return (
    <div className={clsx('tabContents--fileDetails', 'tw-px-[20px]')}>
      <Label
        htmlFor={'p-Source'}
        label={'Source'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Source'} className={clsx('tw-text-cfo-black')}>
          {selectedEmailEntry.source}
        </p>
      </Label>

      <Label
        htmlFor={'p-From'}
        label={'From'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-From'} className={clsx('tw-text-cfo-black')}>
          {fromRecipients}
        </p>
      </Label>

      <Label
        htmlFor={'p-Received'}
        label={'Received'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Received'} className={clsx('tw-text-cfo-black')}>
          <FormattedDate value={selectedEmailEntry.dateAdded} format={'DD-MMM YYYY hh:mm'} />
        </p>
      </Label>

      <Label
        htmlFor={'p-Opened'}
        label={'Opened'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Opened'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={selectedEmailEntry.openedDate}
            userName={selectedEmailEntry.openedBy}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Closed'}
        label={'Closed'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Closed'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={selectedEmailEntry.closedDate}
            userName={selectedEmailEntry.closedBy}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Modified'}
        label={'Modified'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Modified'} className={clsx('tw-text-cfo-black')}>
          <FormattedDateWithUser
            date={selectedEmailEntry.modifiedDate}
            userName={selectedEmailEntry.modifiedBy}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Workstreams'}
        label={'Workstreams'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Workstreams'} className={clsx('tw-text-cfo-black')}>
          <CollapsedList
            items={selectedEmailEntry.workstreams.map((ws) => ws.name)}
            tooltipKey={'workstreams'}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-Tasks'}
        label={'Tasks'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-Tasks'} className={clsx('tw-text-cfo-black')}>
          <CollapsedList
            items={selectedEmailEntry.tasks.map((task) => task.name)}
            tooltipKey={'tasks'}
          />
        </p>
      </Label>

      <Label
        htmlFor={'p-EmailAdd'}
        label={'Email Id'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <p id={'p-EmailAdd'} className={clsx('tw-text-cfo-black')}>
          {selectedEmailEntry.emailIdDetail}
        </p>
      </Label>

      {/* <Label
        htmlFor={'p-accessList'}
        label={'Access List'}
        labelClasses={labelClasses}
        mainContainerClasses={mainContainerClasses}
      >
        <div id="p-accessList" className={clsx('tw-flex tw-items-center', 'tw-m-0')}>
          <AccessList items={selectedEmailEntry.accessList} />
        </div>
      </Label> */}
    </div>
  );
};

export default EmailDetails;
